import { Box, Container } from "@mui/material"
import { useParams } from "react-router-dom"
import { HUB_SECTION_META } from "../seo/staticPageSeoMeta"

export const BlogsHero = () => {
  const { section } = useParams()
  const meta = HUB_SECTION_META[section] || HUB_SECTION_META.all

  return (
    <Box className="w-full py-28 bg-[#0D131E]">
      <Container maxWidth="lg">
        <Box className="w-full py-10 text-white">
          <h1 className="text-[65px] leading-[71.5px] font-medium tracking-normal">
            {meta.h1}
          </h1>
          <p className="text-[16px] leading-[31px] font-normal mt-7">
            {meta.heroDescription}
          </p>
        </Box>
      </Container>
    </Box>
  )
}